import { render, staticRenderFns } from "./menu_popup.vue?vue&type=template&id=e53a6696&scoped=true&"
import script from "./menu_popup.vue?vue&type=script&lang=js&"
export * from "./menu_popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53a6696",
  null
  
)

export default component.exports